export default __webpack_public_path__ + "static/media/afric.118824f0.gif";